import {
  BootstrapAlertComponent,
  EAlertType,
} from './../components/bootstrap-alert/bootstrap-alert.component';
import { AuthService } from '../core/services/acceso/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { A3LCompanyService } from '../core/services/a3LCompany.service';
import { A3LCompany } from '../core/models/a3LCompany.model';
import { Login } from '../core/models/login.model';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Configuration } from '../core/configuration/configuration';
import { PathRoutes } from '../core/configuration/pathRoutes';
import { Token } from '../core/models/token.model';
import { SessionHelper } from '../core/helper/sessionHelper';
import { UserA3LRelations } from '../core/models/userA3LRelations';
import { MessageDialog } from '../components/message-dialog/messageDialog';
import { User } from '../core/models/user.model';
import { UserService } from '../core/services/user.service';
import { AppConfiguracionEntornoService } from '../core/services/appConfiguracionEntornoService.service';
import { LivesSessionHelper } from '../core/helper/livesSessionHelper';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [A3LCompanyService, UserService, AppConfiguracionEntornoService],
})
export class LoginComponent implements OnInit {
  public companies: A3LCompany[];
  userName: string;
  password: string;
  companyId = 0;
  loading: boolean;
  userA3LRelations: UserA3LRelations[];
  user: User;
  appCompanyId: string;

  @ViewChild(BootstrapAlertComponent)
  bootstrapAlertComponent: BootstrapAlertComponent;
  @ViewChild('SubmitButton') SubmitButton: any;

  // Se puede usar un Observable para luego usar *ngFor async.
  // public companies: Observable<Company[]>;

  constructor(
    private _companyService: A3LCompanyService,
    private _authService: AuthService,
    private _userService: UserService,
    private _appConfiguracionEntornoService: AppConfiguracionEntornoService,
    private _router: Router,
    protected _messageDialog: MessageDialog,
    private _session: SessionHelper,
    private _livesSession: LivesSessionHelper,
  ) { }


  /* Método para obtener el id del entorno de hostelhr portal del empleado a partir del id de la empresa */

  private async getEnvironmentByHostelId(id: string) {
    return new Promise((resolve) => {

      /* Link Soluciones */
       this._appConfiguracionEntornoService.getModelByHostelID(id).subscribe(
         data => {
           if (data[0]) {
             this._livesSession.EnvironmentId = data[0].environment1;
             this._livesSession.LivesHR = data[0].livesAppLicence;
             this._livesSession.MyReportin = data[0].myreportinLicence;
             this._livesSession.HostelHR = data[0].hostelLicence;
             this._livesSession.Attendance = data[0].attendanceLicence;
             this._livesSession.Conectia = data[0].conectia;
             this._livesSession.Klikticket = data[0].klikticketLicence;
           }
           resolve(true);
         },
         error => {
           console.error('Error al obtener el entorno:', error);
           resolve(true);
         }
       );

      /* INORCA */
     /*  sessionStorage.setItem('environmentId', 'true');
      sessionStorage.setItem('livesHR', 'true');
      sessionStorage.setItem('myreportin', 'true');
      sessionStorage.setItem('hostelHR', 'true');
      sessionStorage.setItem('attendance', 'true');
      sessionStorage.setItem('conectia', 'true');
      sessionStorage.setItem('klikticket', 'true');
      resolve(true) */
    });
  }


  private getUserLoggedID() {
    let userLogged = this._session.User.UserName;

    this._userService.getAllModels().subscribe(
      data => {
        data.forEach(user => {
          if (user.UserName === userLogged) {
            this._livesSession.AspNetUserId = user.Id.toString();
          }
        });
      },
      error => {
        console.error('Error al obtener el usuario:', error);
      }
    )
    return this._session.User
  }

  onSubmit() {
    const login: Login = {
      UserName: this.userName,
      Password: this.password,
      CompanyId: this.companyId.toString(),
    };

    this.loading = true;

    // realizamos el login
    this._authService.login(login).subscribe(
      async (loginResponse: Token) => {
        if (this._authService.correctLogin(loginResponse)) {

          try {

            let userLogged = this.getUserLoggedID();

            if (userLogged) {
              await this.getEnvironmentByHostelId(userLogged.IdCliente.toUpperCase());

              setTimeout(() => { // para que lea el id 
                this._router.navigate([PathRoutes.home]).then(() => {
                  window.location.reload(); //Para que lea los valores de los sessionStorage de las licencias en el menú 
                });
              }, 3500);
            }
          } catch (error) {
            this.loading = false;
            this._messageDialog.ShowException(error);
            console.error(error);
          }

          try {
            /*  this._router.navigate([PathRoutes.home]); */
            // if (JSON.parse(loginResponse.isAdmin)) {
            //   this._router.navigate([`${PathRoutes.home}/${PathRoutes.myUsers}`]);
            //   return;
            // }
            // this.userA3LRelations = JSON.parse(loginResponse.companies);

            // const firstCompany: UserA3LRelations = this.userA3LRelations.find(
            //   (x: any) => x !== undefined
            // );

            // if (firstCompany !== undefined) {
            //   this.companyId = firstCompany.CompanyCode;
            // }


            // this._companyService
            //   .getByIds(
            //     this.userA3LRelations.map(({ CompanyCode }) => CompanyCode)
            //   )
            //   .subscribe(
            //     (res) => {
            //       this.companies = res;
            //       this.loading = false;
            //       if (this.userA3LRelations.length === 1) {
            //         this.btnContinuarOnClick();
            //       }

            //     },
            //     (err) => {
            //       this.loading = false;
            //       this._messageDialog.ShowException(err);
            //     }
            //   );

          } catch (err) {
            this.loading = false;
            this._messageDialog.ShowException(err);
          }
        } else {
          this._messageDialog.ShowAlert(
            'Se ha producido un error al autenticar el usuario.'
          );
        }
      },
      (err) => {
        this.loading = false;
        this._messageDialog.ShowException(err);
        console.error(err);
      }
    );
  }

  passwordRecoveryOnClick() {
    this._router.navigate([PathRoutes.restorePassword]);
  }

  btnContinuarOnClick() {

    const userA3LRelation = this.userA3LRelations.find((x) => x.CompanyCode === this.companyId);

    if (userA3LRelation) {
      this.loading = true;
      this._userService.selectCompany(userA3LRelation).subscribe(
        res => {

          this._session.CompanyName = this.companies.find(
            (x) => x.companyCode === userA3LRelation.CompanyCode
          ).companyName;
          this._session.CompanyCode = userA3LRelation.CompanyCode.toString();

          this._router.navigate([PathRoutes.home]);
        },
        err => {
          console.error(err);
          this._messageDialog.ShowAlert('No se ha podido seleccionar la empresa');
          this.loading = false;
        }
      );
    }

  }

  ngOnInit() {
    // this.obtenerCompanias();

    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      $('.card').removeClass('card-hidden');
    }, 700);

    //  Init Bootstrap Select Picker
    // if ($('.selectpicker').length !== 0) {
    //   $('.selectpicker').selectpicker();
    // }
  }
}
